/**
 * Schemas Zod para IDs branded do domínio.
 *
 * Convenção: schema valida formato (cuid v2 ou regex específico) e
 * `.transform` aplica a marca branded sem custo runtime. Use em fronteiras
 * (IPC, manifest, config remoto) — nunca em loops hot.
 */
import { z } from 'zod';
import {
  type CollectionId,
  type ColumnId,
  type CrossRelationId,
  type DeviceId,
  isCuid,
  type MessageId,
  type ModuleId,
  type ProjectId,
  type RelationId,
  type RouteId,
  type SessionId,
  type UserId,
  type ValidatorId,
} from '../types/ids.js';

/** Cuid v2 — string lowercase alfanumérica ≥24 chars. */
export const cuidSchema = z.string().refine(isCuid, { message: 'errors.validation.cuid' });

/* ============== Branded ID schemas (cuid v2) ============== */
export const projectIdSchema = cuidSchema.transform((v) => v as ProjectId);
export const moduleIdSchema = cuidSchema.transform((v) => v as ModuleId);
export const collectionIdSchema = cuidSchema.transform((v) => v as CollectionId);
export const columnIdSchema = cuidSchema.transform((v) => v as ColumnId);
export const relationIdSchema = cuidSchema.transform((v) => v as RelationId);
export const routeIdSchema = cuidSchema.transform((v) => v as RouteId);
export const validatorIdSchema = cuidSchema.transform((v) => v as ValidatorId);
export const crossRelationIdSchema = cuidSchema.transform((v) => v as CrossRelationId);
export const userIdSchema = cuidSchema.transform((v) => v as UserId);
export const deviceIdSchema = cuidSchema.transform((v) => v as DeviceId);
export const sessionIdSchema = cuidSchema.transform((v) => v as SessionId);
export const messageIdSchema = cuidSchema.transform((v) => v as MessageId);

/* Pack system schemas (packIdSchema/packVersionSchema/packSignatureSchema) vivem em
 * @planuze/core-kit (`validation/pack-schemas.ts`) — vocabulário do SDK público
 * (ADR-0429). Re-exportados por `@planuze/kernel` via barrel raiz. */
